/**
 * Web-specific API client — thin wrapper around shared createApiClient.
 * Uses cookie-based auth with credentials: 'include'.
 */
import { createApiClient } from '@wovendays/api-client';

export { ApiClientError } from '@wovendays/api-client';

export const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL || '',
  credentials: 'include',
});
